import { render } from "./NewCustomersPage.vue?vue&type=template&id=87fe0366&ts=true"
import script from "./NewCustomersPage.vue?vue&type=script&lang=ts"
export * from "./NewCustomersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__